module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-vue-trigger",
    staticStyle: {
      "top": "0"
    }
  }, [_vm._t("default"), _c('v-waypoint', {
    staticStyle: {
      "height": "1px"
    },
    on: {
      "waypoint-out": _vm.function1,
      "waypoint-in": _vm.function2
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c962ad2e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/block/block-vue-trigger/block-vue-trigger.pug
// module id = 680
// module chunks = 1